/**
 * @date: 2019/8/31
 * @author: xkh
 * @desc:
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routers = [
    {
        path: '/',
        meta: {
            title: '邢凯航'
        },
        component: 'Home'
    }
];

const loadView = (name) => () => import(/* webpackChunkName: "[request]" */ `@/views/${name}/${name}`);
routers.map((r, i) => {
    routers[i].component = loadView(r.component);
});

export default new VueRouter({
    routes: routers,
    mode: 'history'
})
